import request from '@/utils/request'

// 获取合作类别
export function getCategory(languageId) {
  return request({
    url: 'api/businessCooperation/category/' + languageId,
    method: 'get',
  });
}

// 提交合作
export function saveMessage(data) {
  return request({
    url: 'api/businessCooperation/create',
    method: 'post',
    data: data
  });
}

// 获取合作详细信息
export function getBusinessCooperationDetail(code) {
  return request({
    url: 'api/businessCooperation/detail/' + code,
    method: 'get',
  });
}


// WEBPACK FOOTER //
// ./src/api/businessCooperation.js